"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _CoreProps = require("../utilities/CoreProps");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const ActiveFilters = _ref => {
  let {
    filters,
    clearAllFunction,
    clearFilterFunction,
    className
  } = _ref;
  const filterElements = filters.map(filter => /*#__PURE__*/_react.default.createElement("div", {
    className: "tags has-addons",
    key: filter.title
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "tag is-info"
  }, filter.title), /*#__PURE__*/_react.default.createElement("a", {
    className: "tag is-delete",
    onClick: e => {
      e.preventDefault();
      clearFilterFunction(filter.title);
    }
  })));
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('active-filters', className) || undefined
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "active-filters--list"
  }, filterElements), filters.length > 0 ? /*#__PURE__*/_react.default.createElement("a", {
    href: "#",
    onClick: e => {
      e.preventDefault();
      clearAllFunction();
    }
  }, "Clear All Filters") : null);
};
ActiveFilters.propTypes = {
  filters: _propTypes.default.arrayOf(_propTypes.default.shape({
    title: _propTypes.default.string.isRequired
  })).isRequired,
  className: _propTypes.default.string,
  clearAllFunction: _propTypes.default.func.isRequired,
  clearFilterFunction: _propTypes.default.func.isRequired
};
var _default = exports.default = (0, _CoreProps.withUiProps)(ActiveFilters);
//# sourceMappingURL=ActiveFilters.js.map